module.exports = __webpack_public_path__ + "img/sq.0b94433f.png";